import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import logo from '../assets/images/mcc-logo.png';
import background from '../assets/images/bgImage.png';

export default function SignupShell({ children, wide = false }) {
  return <Box sx={{ minHeight: '100vh', width: '100%', boxSizing: 'border-box', px: { xs: 2, sm: 4 }, py: { xs: 3, sm: 6 },
    background: `#f1f7fe url(${background}) center top / cover fixed`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Paper elevation={0} sx={{ width: '100%', maxWidth: wide ? 1180 : 560, boxSizing: 'border-box', overflow: 'hidden',
      borderRadius: '24px', border: '1px solid #dce9f7', boxShadow: '0 20px 65px rgba(27, 79, 137, .12)',
      '& .MuiButton-root': { borderRadius: '10px', textTransform: 'none', fontWeight: 600 },
      '& .MuiOutlinedInput-root': { borderRadius: '10px' }, '& h3': { color: 'primary.heading' } }}>
      <Box sx={{ height: 5, background: 'linear-gradient(90deg, #0C80F3, #77baff, #cce5ff)' }} />
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ px: { xs: 3, sm: 4 }, pt: 3, pb: 2.5, borderBottom: '1px solid #edf3fb' }}>
        <Box component="img" src={logo} alt="" sx={{ width: 36, height: 36, objectFit: 'contain' }} />
        <Typography fontSize={21} fontWeight={700} color="primary.heading">MyCaseCare</Typography>
      </Stack>
      <Box sx={{ p: { xs: 3, sm: 4 }, '& h3': { lineHeight: 1.3 }, '& form': { boxSizing: 'border-box' } }}>{children}</Box>
    </Paper>
  </Box>;
}
